export const remapCatalogOptOutAttributes = (optOuts: OptOutSetting[]) =>
  Object.fromEntries(
    optOuts.map((optOut) => [
      `${optOut.gameCode}_opt_out_attributes`,
      optOut.skip || [],
    ])
  );
